import { render, staticRenderFns } from "./Form422.vue?vue&type=template&id=5f4e93cc&scoped=true&"
import script from "./Form422.vue?vue&type=script&lang=js&"
export * from "./Form422.vue?vue&type=script&lang=js&"
import style0 from "./Form422.vue?vue&type=style&index=0&id=5f4e93cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e93cc",
  null
  
)

export default component.exports